export const SCREEN_NAMES = {
  SYNCED_TRANSACTIONS: "SyncedTransactions",
  RECURRING_TRANSACTIONS: "RecurringTransactions",
  PARENT_CHILD_CATEGORIES: "ParentChildCategories",
  FORECAST_TRANSACTIONS: "ForecastTransactions",
  SCENARIO_TRANSACTIONS: "ScenarioTransactions",
  FORECAST_12M_BALANCES: "Forecast12MonthBalances",
  FORECAST_12M_CATEGORIES: "Forecast12MonthCategories",
  FORECAST_12M_TRANSACTIONS: "Forecast12MonthTransactions",
} as const;

export type ScreenName = (typeof SCREEN_NAMES)[keyof typeof SCREEN_NAMES];
